module.exports = __webpack_public_path__ + "img/culinary_retreat.2de3abc6.jpg";